import React, { Component } from "react";
import styles from "./Percentage.local.scss";
import { IconContext } from "react-icons";
import { TiArrowSortedDown, TiStar, TiWarningOutline } from "react-icons/ti";
import { abbreviateNumber } from "Utils";
import { STATUS } from "Config";
import { getFormatNumber } from "Utils";

class PercentageStatus extends Component {
  render() {
    const { payload } = this.props;
    if (!payload.percentage) {
      return <span className={styles.percentage__na}>N/A</span>;
    }
    if (payload.status === STATUS.ALERT) {
      return (
        <span className={styles.percentage__negative}>
          {/*&nbsp;*/}
          <span className="">
            <IconContext.Provider
              value={{ style: { verticalAlign: "sub", marginBottom: 1 } }}
            >
              <TiArrowSortedDown />
            </IconContext.Provider>
          </span>
          {Math.abs(payload.percentage).toString().length > 7
            ? getFormatNumber(abbreviateNumber(Math.abs(payload.percentage), 0))
            : getFormatNumber(Math.abs(payload.percentage))}%
        </span>
      );
    } else if (payload.status === STATUS.WARNING) {
      return (
        <span className={styles.percentage__warning}>
          {/*&nbsp;*/}
          <span className="">
            <IconContext.Provider
              value={{ style: { verticalAlign: "sub", marginBottom: 1 } }}
            >
              <TiWarningOutline />
            </IconContext.Provider>
          </span>
          {Math.abs(payload.percentage).toString().length > 7
            ? getFormatNumber(abbreviateNumber(Math.abs(payload.percentage), 0))
            : getFormatNumber(Math.abs(payload.percentage))}%
        </span>
      );
    } else if (payload.status === STATUS.GREAT) {
      return (
        <span className={styles.percentage__great}>
          {/*&nbsp;*/}
          <span className="">
            <IconContext.Provider
              value={{ style: { verticalAlign: "sub", marginBottom: 1 } }}
            >
              <TiStar />
            </IconContext.Provider>
          </span>
          <span>
            {Math.abs(payload.percentage).toString().length > 7
              ? getFormatNumber(
                  abbreviateNumber(Math.abs(payload.percentage), 0)
                )
              : getFormatNumber(payload.percentage)}%
          </span>
        </span>
      );
    } else {
      return (
        <span className={styles.percentage__positive}>
          <span>
            {Math.abs(payload.percentage).toString().length > 7
              ? getFormatNumber(
                  abbreviateNumber(Math.abs(payload.percentage), 0)
                )
              : getFormatNumber(payload.percentage)}%
          </span>
        </span>
      );
    }
  }
}

export default PercentageStatus;



// WEBPACK FOOTER //
// ./src/components/Common/Percentage/PercentageStatus.js